import { differenceInCalendarDays } from 'date-fns';

function getDate(): Date {
    const currentDate = new Date();
    return new Date(currentDate.setHours(currentDate.getHours() - 3));
}

function parseDateSafe(value: string | number): Date {
    if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
        const [year, month, day] = value.split('-').map(Number);
        return new Date(year, month - 1, day);
    }
    return new Date(value);
}

function formatDateBR(date: Date | undefined | null | string | number): string {
    if (date === undefined || date === null) return '';

    if (typeof date === 'string' || typeof date === 'number') {
        const _date = parseDateSafe(date);

        return `${_addedLeftZero(_date.getDate())}/${_addedLeftZero(
            _date.getMonth() + 1,
        )}/${_date.getFullYear()}`;
    } else {
        return `${_addedLeftZero(date.getDate())}/${_addedLeftZero(
            date.getMonth() + 1,
        )}/${date.getFullYear()}`;
    }
}

function _addedLeftZero(number: number): string {
    let numberStr = number.toString();

    if (numberStr.length === 1) numberStr = '0' + numberStr;

    return numberStr;
}

function change5min(date: Date): boolean {
    const currentDate = new Date(); // Pega a data e hora atuais
    const last5min = new Date(date.getTime() + 5 * 60000); // Adiciona 5 minutos à data fornecida

    const lastMin = last5min.getMinutes();
    const lastHor = last5min.getHours();
    const lastDay = last5min.getDay();

    const min = currentDate.getMinutes();
    const hor = currentDate.getHours();
    const day = currentDate.getDay();

    if (lastHor + 3 === hor && lastDay === day) {
        if (min <= lastMin) {
            return true;
        }
    }

    return false;
}

function compare(d1: Date | undefined, d2: Date | undefined): boolean {
    if (!d1 || !d2) return false;

    const date1Stripped = d1.toISOString().split('T')[0];
    const date2Stripped = d2.toISOString().split('T')[0];

    return date1Stripped > date2Stripped;
}

function resetHmS(date: Date): Date {
    const resetDate = new Date(date);
    resetDate.setHours(0, 0, 0, 0);
    return resetDate;
}

function addHoursEndAt(date: Date): Date {
    date.setHours(23, 59, 59, 999);
    return date;
}

function resetHours(date: Date | null): Date | null {
    if (date === null) {
        return null;
    }

    date.setHours(0, 0, 0, 0);
    return date;
}

function addMinutesInDate(date: Date, minutes: number): Date {
    return new Date(date.getTime() + minutes * 60000); // 60000 milissegundos = 1 minuto
}

function greaterThan(d1: Date | undefined, d2: Date | undefined): boolean {
    if (!d1 || !d2) return false;

    const date1Stripped = d1.toISOString().split('T')[0];
    const date2Stripped = d2.toISOString().split('T')[0];

    return date1Stripped > date2Stripped;
}

function formatDateAndHours(date: Date | undefined | null | string | number): string {
    if (date === undefined || date === null) return '';

    const _date = typeof date === 'string' || typeof date === 'number'
        ? new Date(date)
        : date;

    return `${_addedLeftZero(_date.getDate())}/${_addedLeftZero(
        _date.getMonth() + 1
    )}/${_date.getFullYear()} ${_addedLeftZero(_date.getHours())}:${_addedLeftZero(_date.getMinutes())}`;
}

function addDays(days: number): Date {
    const date = new Date();
    date.setDate(date.getDate() + days);
    return date;
}

// Dias de atraso equivalentes a uma data de vencimento (hoje - data), inverso de dateFromDaysOverdue.
function daysOverdueFromDate(dueDate: Date): number {
    return differenceInCalendarDays(resetHmS(new Date()), resetHmS(dueDate));
}

// Data de vencimento equivalente a X dias de atraso hoje. Mesma conta usada no
// rótulo "Faixa de cobrança de X até Y" (hoje - dias); o resultado muda todo dia,
// pois a base real é a data de vencimento, não uma data fixa.
function dateFromDaysOverdue(days: number): Date {
    return addDays(-days);
}

export const dateUtils = {
    getDate,
    formatDateBR,
    parseDateOnly: parseDateSafe,
    compare,
    resetHmS,
    change5min,
    addMinutesInDate,
    addHoursEndAt,
    greaterThan,
    formatDateAndHours,
    addDays,
    resetHours,
    daysOverdueFromDate,
    dateFromDaysOverdue,
};
